<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useErrorStore } from '@/stores/error'

export default defineComponent({
  name: 'FieldErrorMessage',

  props: {
    /**
     * フィールド名
     */
    field: {
      type: String,
      default: '',
    },

    /**
     * エラーメッセージを表示するかどうか
     *
     * @description
     *  バリデーションはしたいが、エラーメッセージは隠したい場合（hidden 要素等）、
     *  特に、「勤務先名」のように入力フィールドに付随する hidden 要素が存在する場合において、入力フィールドの入力状況によって hidden 要素の方のエラーを表示するかどうか制御するような状況で使用する。
     *  バリデーションエラーメッセージのアニメーションの兼ね合いで DOM が存在していないといけないため、v-if 制御ではなく、CSS 側での表示制御とする
     */
    showMessage: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const errorStore = useErrorStore()

    const errorMessages = computed(() => {
      return errorStore.getErrorMessagesByFieldName(props.field)
    })

    // 消去アニメーション中はメッセージを残したまま非表示状態に遷移させる
    const isActive = computed<boolean>(() => {
      return errorStore.isShowErrorsByFieldName(props.field)
    })

    return {
      // store
      errorStore,

      // computed
      errorMessages,
      isActive,
    }
  }
})
</script>

<template>
  <div
    :class="[
      'o-list__errorMessage',
      { 'is-active': isActive },
    ]"
    :data-hidden="!showMessage"
    :style="{ transitionDuration: `${errorStore.context.animationDelay}s` }">
    <ul
      class="o-list__errorMessage--items"
      :style="{ transitionDuration: `${errorStore.context.animationDelay}s` }">
      <li
        v-for="(message, index) in errorMessages"
        :key="index"
        class="o-list__errorMessage--item"
        v-html="message" />
    </ul>
  <!-- /.o-list__errorMessage --></div>
</template>

<style lang="sass" scoped>
// object
.o-list__errorMessage
  $root: &
  display: grid
  grid-template-rows: 0fr
  overflow: hidden
  margin-top: 0.3em
  opacity: 0
  transition: // transition-duration は store 側で管理し、style 属性で付与する。（エラーメッセージのフェードアウトとエラー配列のクリアのタイミングを同期する必要があるため。）
    property: all
    timing-function: ease

  // エラーが 1 件もない場合は margin 打消
  &:not(:has(> ul > li))
    margin-top: 0

  & &--items
    overflow: hidden
    line-height: 1.4

  & &--item
    color: $font-error
    font:
      size: $font-small
      weight: bold
    text-align: left

  &.is-active:not([data-hidden="true"])
    grid-template-rows: 1fr
    opacity: 1
</style>
